import {
  createPermissionCheck,
  ENTRY_POINTS,
  PERMISSION_ACTIONS,
  PERMISSION_GROUPS,
} from "components/permissions/utils/permission-utils";

const CommunicationConst = {
  basePath: "/communication-board",
  storageKey: "communication-board-store-v2",
  pageSize: 10,
  permissions: {
    VIEW: createPermissionCheck(
      "permission_view_communication_board",
      ENTRY_POINTS.LIBRARY,
      PERMISSION_GROUPS.COMMUNICATION_BOARD,
      PERMISSION_ACTIONS.VIEW
    ),
    EDIT_RAW: createPermissionCheck(
      "permission_edit_communication_board_raw",
      ENTRY_POINTS.LIBRARY,
      PERMISSION_GROUPS.COMMUNICATION_BOARD,
      PERMISSION_ACTIONS.EDIT
    ),
    APPROVE: createPermissionCheck(
      "permission_change_communication_board_status",
      ENTRY_POINTS.LIBRARY,
      PERMISSION_GROUPS.COMMUNICATION_BOARD,
      PERMISSION_ACTIONS.CHANGE
    ),
  },
  statuses: {
    PENDING: "pending",
    UNIDENTIFIED: "unidentified",
    APPROVED: "approved",
    DISMISSED: "dismissed",
  } as const,
};

export default CommunicationConst;
